// 入力フォームの定義
const FORMS = [
  /*
  {
    key: 'inquiryType',
    label: 'お問い合わせ種別',
    type: 'select',
    requierd: true,
    options: [
      { label: '資料請求', value: '資料請求' },
      { label: '見積依頼', value: '見積依頼' },
      { label: 'お問い合わせ', value: 'お問い合わせ' },
    ],
  },
  */
  {
    key: 'organization',
    label: '法人・組織名',
    placeholder: '株式会社SSマーケット',
    requierd: true,
    hint: '個人からのお問い合わせはご対応をお断りしております。予めご了承ください。',
  },
  {
    key: 'name',
    label: 'ご担当者名',
    placeholder: '法人太郎',
    requierd: true,
  },
  {
    key: 'email',
    label: 'メールアドレス',
    placeholder: 'rental@example.com',
    requierd: true,
    rules: ['email'],
    hint: 'Gmail等のフリーメールや携帯キャリアメールはご利用いただけません。',
  },
  {
    key: 'tel',
    label: '日中ご連絡可能な電話番号',
    placeholder: '00-0000-0000',
    requierd: true
  },
  {
    key: 'inquiry',
    label: 'お問い合わせ内容',
    placeholder: 'お問い合わせ内容をご記入ください。',
    type: 'textarea',
  },
]